module.exports = __webpack_public_path__ + "assets/0c6d86ce3149aa0170aaac7a9e486d84.jpg";